import { Entry } from '../Entry'

export function Entry20241029() {
  return (
    <Entry title="2024 Oct 10 - v3.9.0">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/16103/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
